import React from "react";
import { Descriptions } from "antd";
import { TagOutlined, BarcodeOutlined } from "@ant-design/icons";

const EquipmentDisplay = ({ equipment }) => {
  return (
    <Descriptions bordered column={1}>
      <Descriptions.Item
        label={
          <>
            <TagOutlined /> Brand
          </>
        }
      >
        {equipment.brand}
      </Descriptions.Item>
      <Descriptions.Item
        label={
          <>
            <BarcodeOutlined /> Model
          </>
        }
      >
        {equipment.model}
      </Descriptions.Item>

      <Descriptions.Item label={<>Category</>}>
        {equipment.category}
      </Descriptions.Item>
      <Descriptions.Item label={<>Part Number</>}>
        {equipment.partNumber}
      </Descriptions.Item>
      <Descriptions.Item label={<>Price</>}>
        {equipment.price}
      </Descriptions.Item>
      <Descriptions.Item label={<>Orderable</>}>
        {equipment.orderable ? "Yes" : "No"}
      </Descriptions.Item>
      <Descriptions.Item label={<>Calibratable</>}>
        {equipment.calibrationAvailable ? "Yes" : "No"}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default EquipmentDisplay;
